var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"g-booth-preview"},[_c('g-preview-form',{attrs:{"src":_vm.src},model:{value:(_vm.booth),callback:function ($$v) {_vm.booth=$$v},expression:"booth"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }